import {handleExpiredToken} from '../../helpers/removeCurrUser'

export const postRequest = async ({url, data}) => {
    try {
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        const isJson = response.headers.get('content-type')?.includes('application/json')
        const returnedData = isJson && await response.json()

        // check for error response
        if (!response.ok) {

            if (response.status === 401) {
                handleExpiredToken()
                return
            }
            // get error message from body or default to response status
            return {
                error: returnedData.error,
                status: response.status,
                prettyError: returnedData.prettyError
            }
        }

        return returnedData

    } catch (err) {
        console.error(err)
    }
}